import type { RemoteSearchCache } from "./types";
import type { EnabledGlobalSearchEntities } from "../../../../types/Institution.types";

export const SEARCH_DELAY_MS = 600;

export const MIN_SEARCH_TERM_LENGTH = 3;

export const DEFAULT_SEARCH_ENTITIES: EnabledGlobalSearchEntities = {
  accounts: true,
  cards: true,
  pages: true,
  transactions: true,
};

export const INITIAL_REMOTE_CACHE: RemoteSearchCache = new Map([
  ["", { pages: [], transactions: [] }],
]);
